import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ element: Element, restricted = false }) => {
  const userToken = localStorage.getItem('authToken');
  if (userToken && restricted) {
    return <Navigate to="/" replace />;
  }

  return <Element />;
};

export default PublicRoute;
